import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { SupportFamily } from "../../../../http/deckDesigner/types/supportFamilies";
import useDeckSupportFamiliesApi from "../../../../http/deckDesigner/useSupportFamilies";
import SupportFamilyForm from "./SupportFamilyForm";

const AdminSupportFamilies: FC = () => {
  const i18n = useI18n();
  const supportFamiliesApi = useDeckSupportFamiliesApi();

  return (
    <AdminCrudTable<SupportFamily>
      filterPrefix="support_families"
      useList={supportFamiliesApi.useDeckSupportFamilies}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.supportFamilies.maxLiveLoad}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.screwFamilies.plural}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{!!item.maxLiveLoad && `${item.maxLiveLoad} ${i18n.translation.common.unitKn}`}</TableCell>
          <TableCell>{item.screwFamilies.map((screwFamily) => screwFamily.name).join(", ")}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          supportFamiliesApi.updateDeckSupportFamilyVisibility(item.code, { visibility }),
        updateOrder: (item, order) => supportFamiliesApi.updateDeckSupportFamilyOrder(item.code, { order }),
      }}
      renderForm={(item, onClose) => <SupportFamilyForm supportFamily={item} onClose={onClose} />}
    />
  );
};

export default AdminSupportFamilies;
